import { TAutoLogoutConfig } from "@app/core/auto-logout/auto-logout.type";
import { InjectionToken } from "@angular/core";

export const AUTO_LOGOUT_CONFIG =
  new InjectionToken<TAutoLogoutConfig>('auto_logout_config');
